import { render, staticRenderFns } from "./ArtworXPreviewFields.vue?vue&type=template&id=2bc32ed5&scoped=true&"
import script from "./ArtworXPreviewFields.vue?vue&type=script&lang=ts&"
export * from "./ArtworXPreviewFields.vue?vue&type=script&lang=ts&"
import style0 from "./ArtworXPreviewFields.vue?vue&type=style&index=0&id=2bc32ed5&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc32ed5",
  null
  
)

export default component.exports